export default __webpack_public_path__ + "static/media/dyeing-min.159ac5f8.webp";